const sumItems = (items) => {
    const itemsCounter = items.reduce((total, product) => total + product.count, 0)
    return { itemsCounter }
}

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD_ITEM": {
            if (!state.items.find(item => item.id === action.payload.id)) {
                state.items.push({ ...action.payload, count: 1 })
            }
            localStorage.setItem('favorite', JSON.stringify({
                ...state,
                items: [...state.items],
                ...sumItems(state.items)
            }))
            return {
                ...state,
                items: [...state.items],
                ...sumItems(state.items)
            }
        }
        case "REMOVE_ITEM": {
            const newitems = state.items.filter(i => i.id !== action.payload)
            localStorage.setItem('favorite', JSON.stringify({
                ...state,
                items: [...newitems],
                ...sumItems(newitems)
            }))
            return {
                ...state,
                items: [...newitems],
                ...sumItems(newitems)
            }
        }
        // case "ORDER": {
        //     switch (action.payload) {
        //         case "highest_price": {
        //             const newitems = state.items.sort((a, b) => {
        //                 if (!!a.off_price) {
        //                     return b.price - a.off_price
        //                 } else if (!!b.off_price) {
        //                     return b.off_price - a.price
        //                 }
        //                 return b.price - a.price
        //             });
        //             return {
        //                 ...state,
        //                 items: [...newitems],
        //                 ...sumItems(newitems)
        //             }
        //         }
        //         case "lowest_price": {
        //             const newitems = state.items.sort((b, a) => {
        //                 if (!!a.off_price) {
        //                     return b.price - a.off_price
        //                 } else if (!!b.off_price) {
        //                     return b.off_price - a.price
        //                 }
        //                 return b.price - a.price
        //             });
        //             return {
        //                 ...state,
        //                 items: [...newitems],
        //                 ...sumItems(newitems)
        //             }
        //         }
        //         default:
        //             return state;
        //     }

        // }
        case "CLEAR": {
            localStorage.setItem('faverite', JSON.stringify({
                items: [],
                itemsCounter: 0,
            }))
            return {
                items: [],
                itemsCounter: 0,
            }
        }
        case "INIT_STORED_FAVE":
            return action.payload

        default:
            return state
    }
}

export default reducer